<bdo-recent-home
  [isMove]="false"
  [trackingLocation]="TRACKING.LOCATION.CONTRACT_END_RECENT"
></bdo-recent-home>
